import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';

Vue.use(Vuetify,{iconfont: 'md'});

export default new Vuetify({
});
